export default "__VITE_ASSET__Va_EdLIj__"